import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useBuildCommonFQEventProperties } from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';

import { InfluencerLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/InfluencerLayout';

export const InsightInfluencer = () => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();
  const {
    onSubmit, resource,
  } = useMetaLayoutContext();

  const onNext = () => {
    logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
      eventProperties: {
        ...buildCommonFQEventProperties(resource),
        insightId: resource.attr('insightId'),
        insightReferenceName: resource.attr('insightReferenceName'),
      },
    });
    onSubmit();
  };

  return (
    <InfluencerLayout handleSubmit={onNext} handleLowerCTAClicked={onNext} showContactForm={false} />
  );
};
